import React, { useState, useEffect } from "react";

import { GET_USER_APPROVALS, APPROVE_USER, UPDATE_UNLOADER_MAPPING } from '../../../common/URLs';
import { loaderService } from '../../../common/custom-loader/loader-service';
import { ConfirmationPopover } from '../../../common/commonPopovers/confirmationPopover';
import { getLocalStorageItem } from '../../../common/localStorageUtils';
import { DataGrid } from '@mui/x-data-grid';
import { QuickSearchToolbar } from '../../../payment/common/commonFunctions';
import { Container, IconButton, Tooltip, Box, FormControl, FormControlLabel, RadioGroup, Radio, Button, Dialog, DialogTitle, DialogContent, DialogActions } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useData } from '../../../App';
import { sendSignupLink } from '../../../common/Utils';
import { toast } from 'react-toastify';
import { FileUploadMUI } from "../../../common/fileUpload/fileUploadMUI";
import { ApproveIcon } from "../../../common/icons";
import apiClient from "../../../axios";
import { CloseIcon, EditIcon, SaveIcon, SearchIcon, UpdateIcon } from "../../../common/icons";

const UserOnboardingApproval = (props) => {
    const { t } = useTranslation();
    const [userDetails, setUserDetails] = useState([]);
    const { loginUserDetails } = useData();
    const [logModalOpen, setLogModalOpen] = useState(false);
    const handleLogModalOpen = () => setLogModalOpen(true);
    const handleLogModalClose = () => setLogModalOpen(false);
    const [selectedRow, setSelectedRow] = useState();
    const [userApprovalDialogOpen, setUserApprovalDialogOpen] = useState(false);
    const [rolesForApproval, setRolesForApproval] = useState([]);

    function approveUser() {
        loaderService.showLoader();
        var userApprovalRoles = selectedRow.userRoles.map(obj => {
            return {
                roleId: obj.roleId,
                roleName: obj.roleName,
                actionTaken: obj.actionTaken,
                approvalStatus: obj.approvalStatus
            };

        })
        apiClient
            .post(APPROVE_USER,
                {
                    "id": selectedRow.userApprovalID,
                    "status": "Completed",
                    "userRoleApprovals": userApprovalRoles
                },
                {
                    headers: {
                        Authorization: 'Bearer ' + getLocalStorageItem('id_token'),
                    }
                },
            )
            .then((response) => {
                setUserApprovalDialogOpen(false);
                sendSignupLink(selectedRow.emailAddress, sendSignUpCallback);
                getUserApprovals();
                toast.success("Successfully approved/rejected user roles.")
                loaderService.hideLoader();
            })
            .catch(function (error) {
                console.log(error);
                loaderService.hideLoader();
            });
    }
    const sendSignUpCallback = (response) => {
        toast.success(response?.message);
        selectedRow.userRoles.forEach((role) => {
            updateMapping("LLE", selectedRow.userApprovalCreatedByUrn, selectedRow.emailAddress, role.roleName, "");
        });
    }
    useEffect(() => {
        getUserApprovals();
    }, []);


    function getUserApprovals() {
        apiClient
            .post(GET_USER_APPROVALS,
                {
                    "loginId": loginUserDetails.userId ? loginUserDetails.userId : getLocalStorageItem('uuid'),
                    "status": ""

                },
                {
                    headers: {
                        Authorization: 'Bearer ' + getLocalStorageItem('id_token'),
                    }
                }, null
            )
            .then((response) => {
                setUserDetails(response.data.users);
            })
            .catch(function (error) {
                console.log(error);
            });
    }
    function onApproveSubmit(e, row) {
        setSelectedRow(row);
        row.userRoles.map(obj => {
            obj.approvalStatus = "Approved";
        })
        setUserApprovalDialogOpen(true);

    }
    function onApproveCallback() {
        handleLogModalClose();
        approveUser(selectedRow);
    }
    const updateMapping = (stakeholderType, stakeholderUrn, mappedUserEmailId, mappedUserRoleName, weighbridgeId) => {
        loaderService.showLoader();
        apiClient
            .post(
                UPDATE_UNLOADER_MAPPING,
                {
                    "stakeholderType": stakeholderType,
                    "stakeholderUrn": stakeholderUrn,
                    "mappedUserEmailId": mappedUserEmailId,
                    "mappedUserRoleName": mappedUserRoleName,
                    "weighbridgeId": weighbridgeId
                },
                {
                    headers: {
                        Authorization: "Bearer " + getLocalStorageItem('id_token'),
                    },
                }
            )
            .then((response) => {
                loaderService.hideLoader();
                getUserApprovals();
            })
            .catch(function (error) {
                loaderService.hideLoader();
                toast.error(error.message);
            });
    };
    const radioChange = (e, roleId, value) => {
        selectedRow.userRoles.map(obj => {
            if (obj.roleId == roleId) {
                obj.approvalStatus = value;
            }

        });
    };

    const columns = [
        {
            field: 'firstname', headerName: t('preReg.name'), width: 180,
            valueGetter: (params) => {
                if (params) {
                    return (params.row.salutation + " " + params.row.firstname + " " + (params.row.middlename ? (params.row.middlename + " ") : "") + " " + (params.row.lastname ? params.row.lastname : ""))
                } else return '-'
            }
        },
        {
            field: 'gender', headerName: t('preReg.gender'), width: 80,
        },
        {
            field: 'mobileNo', headerName: t('preReg.mobileNo'), width: 100,
        },
        {
            field: 'emailAddress', headerName: "Email Address", width: 200
        },
        {
            field: 'govtID', headerName: "Govt ID", width: 150,
            valueGetter: (params) => {
                if (params) {
                    return (params.row.govtIdProofType + ": (" + params.row.govtIdProofNumber + ")")
                } else return '-'
            }
        },
        {
            field: 'IDProofDoc', headerName: "ID Proof Document", width: 150,
            renderCell: (params) => {
                return (
                    <>
                        <FileUploadMUI key="IDProof"
                            documentList={params.row.documents}
                            documentType="IDProof"
                            stakeholderDetailId={params.row.id}
                            title={t('reg.uploadIDProofDoc')}
                            stakeHolderType="user"
                            disabled="true"
                            isViewOnly="true"
                            title=""
                        />
                    </>
                )
            }
        },
        {
            field: 'roleName',
            headerName: 'Roles',
            width: 300,
            valueGetter: (params) => {
                if (params) {
                    return params.row?.userRoles?.map(obj =>
                        obj.roleName + ' (' + obj.actionTaken + ':' + obj.approvalStatus +')' 
                    ).join(',\n');
                } else return '-';
            },
            renderCell: (params) => {
                return (
                    <div style={{ whiteSpace: 'pre-line' }}>
                        {params.row?.userRoles?.map(obj =>
                            obj.roleName + ' (' + obj.actionTaken + ' : ' + obj.approvalStatus + ')' 
                        ).join(',\n')}
                    </div>
                );
            }
        },
        {
            field: 'createdByName', headerName: "Initiated By", width: 150
        },
        {
            field: 'userApprovalCreatedByUrn', headerName: "Stakeholder URN", width: 150, hide: localStorage.getItem('role') !== "PIT-Processing"
        },
        {
            field: 'userApprovalStatus', headerName: "Approval Status", width: 150
        },
        {
            field: 'Action', headerName: 'Action', width: 60,
            renderCell: (params) => {
                return (
                    <Tooltip title="Approve">
                        <IconButton color="primary" hidden={params?.row?.isActive == "2" || params?.row?.userApprovalStatus == "Completed"} onClick={(e) => onApproveSubmit(e, params?.row)} >
                            <ApproveIcon />
                        </IconButton>
                    </Tooltip>
                );
            }
        }
    ];

    const roleColumns = [
        {
            field: 'roleName', headerName: 'Role Name', width: 150,
        },
        {
            field: 'actionTaken', headerName: 'Action Taken', width: 100,
        },
        {
            field: 'Action', headerName: 'Action', width: 230,
            renderCell: (params) => {
                return (
                    <FormControl >
                        <RadioGroup
                            row >
                            <FormControlLabel control={<Radio name="roleApprovalAction" checked={params.row.approvalStatus=="Approved"} onChange={(e) => radioChange(e, params.row.roleId, "Approved")} />} label="Approve" />
                            <FormControlLabel control={<Radio name="roleApprovalAction" checked={params.row.approvalStatus == "Rejected"}  onChange={(e) => radioChange(e, params.row.roleId, "Rejected")} />} label="Reject" />
                        </RadioGroup>
                    </FormControl>
                );
            }
        }
    ];
    return (

        <>
            <Container fluid>
                {userDetails && userDetails?.filter((item1) => item1.isActive === 1) ?
                    <Box style={{ height: 500, width: '100%' }} >
                        <DataGrid
                            sx={{
                                '&.MuiDataGrid-root--densityCompact .MuiDataGrid-cell': { py: '8px' },
                                '&.MuiDataGrid-root--densityStandard .MuiDataGrid-cell': { py: '15px' },
                                '&.MuiDataGrid-root--densityComfortable .MuiDataGrid-cell': { py: '22px' },
                            }}
                            rows={userDetails}
                            columns={columns}
                            pageSize={10}
                            getRowHeight={() => 'auto'}
                            getRowId={(row) => row?.userApprovalID}
                            components={{ Toolbar: QuickSearchToolbar }}
                        />
                    </Box> : null}
            </Container>
            <Dialog open={userApprovalDialogOpen} onClose={() => setUserApprovalDialogOpen(false)} fullWidth maxWidth="sm">
                <DialogTitle>User Roles Approval</DialogTitle>
                <DialogContent>
                    <Box style={{ height: 300, width: '100%' }} >
                        <DataGrid
                            sx={{
                                '&.MuiDataGrid-root--densityCompact .MuiDataGrid-cell': { py: '8px' },
                                '&.MuiDataGrid-root--densityStandard .MuiDataGrid-cell': { py: '15px' },
                                '&.MuiDataGrid-root--densityComfortable .MuiDataGrid-cell': { py: '22px' },
                            }}
                            rows={selectedRow?selectedRow.userRoles:[]}
                            columns={roleColumns}
                            pageSize={10}
                            getRowHeight={() => 'auto'}
                            getRowId={(row) => row?.roleId}
                        />
                    </Box>
                </DialogContent>
                <DialogActions>
                    <Button startIcon={<CloseIcon />} sx={{ minWidth: 100 }} variant="outlined" onClick={() => setUserApprovalDialogOpen(false)}>Cancel</Button>
                    <Button startIcon={<SaveIcon />} sx={{ minWidth: 100, ml: 1 }} variant="contained" onClick={() => handleLogModalOpen()}>Save</Button>
                </DialogActions>
            </Dialog>
            <ConfirmationPopover onConfirm={onApproveCallback} onOpen={logModalOpen} action="Submit" onClose={handleLogModalClose} />
        </>
    )
}

export default UserOnboardingApproval;
